const Menus = [
    {
        name : 'Home',
        href : '/'
    },
    {
        name : 'About',
        href : '/about'
    },

    {
        name : 'Shop',
        href : '/shop'
    },
    {
        name : 'Features',
        href : '/features'
    },
    {
        name : 'Blog',
        href : '/blog'
    },
    {
        name : 'Contact',
        href : '/contact'
    }
]

export default Menus;